import { LazyRelayModuleWrapper } from '@ms/yammer-relay/dist/environment';
import type { FC } from 'react';
import React from 'react';

import { LoadablePushNotificationsDeprecationBanner } from '../components/PushNotificationsDeprecationBanner';

export const PushNotificationsDeprecationBannerIntegration: FC = () => (
  <LazyRelayModuleWrapper>
    <LoadablePushNotificationsDeprecationBanner />
  </LazyRelayModuleWrapper>
);
